(function() {
    'use strict';
    angular
        .module('appback')
        .controller('ShippingController', ShippingController)

    ShippingController.$inject = ["ShippingService", "$scope", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "Upload", "QueueService"];

    function ShippingController(ShippingService, $scope, $http, $timeout, $uibModal, $log, $document, $sce, Upload, QueueService) {
        var vm = this;
        vm.firmaLoading = false;
        vm.firmaUploading = false;
        vm.firmaUploadProgress = 0;
        vm.firmaDragOver = false;
        vm.firmaJobId = null;
        vm.firmaErrorMessage = '';
        vm.signedDocs = [];
        vm.signedDocSeleccionado = null;
        vm.filtroCliente = '';

        // Inicializar fechas con hoy por defecto
        var hoy = new Date();
        var año = hoy.getFullYear();
        var mes = String(hoy.getMonth() + 1).padStart(2, '0');
        var dia = String(hoy.getDate()).padStart(2, '0');
        var fechaHoy = año + '-' + mes + '-' + dia;

        vm.filtroFechaInicio = null;
        vm.filtroFechaFin = null;
        vm.clientes = [];

        vm.shippingS = ShippingService;

        vm.entregarCubeta = function(id) {
            ShippingService.entregarCubeta(id);

        }

        // POD = proof of delivery
        vm.getShippingPod = function(id) {
            ShippingService.getShippingPod(id).then(function(result) {
                if (result) {
                    console.log(result)

                    var fileUrl = result[0].url;
                    var url = `/backend/shipping/downloadreport?file_url=${fileUrl}`;

                    // Crear un enlace temporal
                    var link = document.createElement('a');
                    link.href = url;
                    link.download = ''; // Puedes poner un nombre de archivo si lo deseas
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }).catch(function(error) {
                // El error ya se maneja en el servicio con el modal
                console.error('Error al obtener el comprobante de entrega:', error);
            });


        }
        vm.checkShippingStatus = function(id) {
            ShippingService.eventos[id] = [];
            ShippingService.loadings[id] = true;

            ShippingService.getShippingStatus(id).then(function(result) {
                console.log(result)
                if (result.element) {
                    ShippingService.eventos[id] = result.element.shipping;
                }

                if (result.element.column) {
                    let data = result.element.column;
                    console.log(result)
                    document.querySelectorAll('tr').forEach(tr => {
                        // Buscamos si en la fila hay un <td> con el pedido
                        const tdPedido = Array.from(tr.querySelectorAll('td')).find(td => td.textContent.includes(data.shipping_num));

                        if (tdPedido) {
                            // Encontramos el <td> que contiene el link de shippingstatus en esa misma fila
                            const tdShipping = tr.querySelector('td a[href*="shippingstatus"]')?.closest('td');
                            if (tdShipping) {
                                // Por ejemplo, cambiamos su contenido
                                tdShipping.innerHTML = `<a href="/backend/altcrm/content/view?lang_id=1&id=${data.status_id.id}&type=shippingstatus">${data.status_id.currentstatus}</a>`;


                                console.log("TD modificado:", tdShipping);
                            }
                        }
                    });


                }
                ShippingService.loadings[id] = false;
            }).catch(() => {
                ShippingService.loadings[id] = false;

            });


        }



        // Configurar dropzone
        vm.initDropzone = function() {
            var dropzone = document.getElementById('dropzone');
            var pdfInput = document.getElementById('pdfInput');

            if (!dropzone || !pdfInput) return;

            dropzone.addEventListener('click', function() {
                pdfInput.click();
            });

            dropzone.addEventListener('dragover', function(e) {
                e.preventDefault();
                $scope.$apply(function() {
                    vm.firmaDragOver = true;
                });
            });

            dropzone.addEventListener('dragleave', function(e) {
                e.preventDefault();
                $scope.$apply(function() {
                    vm.firmaDragOver = false;
                });
            });

            dropzone.addEventListener('drop', function(e) {
                e.preventDefault();
                $scope.$apply(function() {
                    vm.firmaDragOver = false;
                });
                var files = e.dataTransfer.files;
                if (files.length > 0) {
                    vm.uploadFileFirma(files[0]);
                }
            });

            pdfInput.addEventListener('change', function(e) {
                if (e.target.files.length > 0) {
                    vm.uploadFileFirma(e.target.files[0]);
                }
            });
        };

        // Seleccionar archivo
        vm.selectFile = function() {
            var pdfInput = document.getElementById('pdfInput');
            if (pdfInput) {
                pdfInput.click();
            }
        };

        // Subir archivo PDF
        vm.uploadFileFirma = function(file) {
            if (!file) return;

            vm.firmaUploading = true;
            vm.firmaUploadProgress = 0;
            vm.firmaErrorMessage = '';

            Upload.upload({
                url: '/backend/shipping/procesar-firma-documentos',
                data: { file: file }
            }).then(function(resp) {
                vm.firmaUploading = false;
                vm.firmaUploadProgress = 100;
                QueueService.loadingModal("En proceso de agrupacion...", "El documento esta siendo analizado y separado por cliente...", resp.data.id).then(() => {
                    vm.cargarSignedDocs();
                });
            }, function(resp) {
                vm.firmaUploading = false;
                vm.firmaErrorMessage = 'Error al procesar el archivo.';
            }, function(evt) {
            });
        };
        vm.cargarSignedDocs = function() {
            console.log('Cargando documentos con filtros:', {
                cliente: vm.filtroCliente,
                inicio: vm.filtroFechaInicio,
                fin: vm.filtroFechaFin
            });
            vm.firmaLoading = true;
            vm.signedDocSeleccionado = null;
            ShippingService.getPdfAgrupados(
                vm.filtroCliente,
                vm.filtroFechaInicio,
                vm.filtroFechaFin
            ).then(function(response) {
                var docs = (response || []).map(function(doc) {
                    var processed = angular.copy(doc);
                    // Parsear fecha
                    if (processed.created) {
                        var dateStr = processed.created.replace(' ', 'T');
                        processed.createdDate = new Date(dateStr);
                    }
                    // Parsear y transformar el campo 'data'
                    if (typeof processed.data === 'string') {
                        try {
                            var parsed = JSON.parse(processed.data);
                            var transformed = { pdfs: {}, emails: {} };

                            // Determinar formato: nuevo (con pdfs y emails) o antiguo (cliente -> ruta)
                            if (parsed.pdfs && parsed.emails) {
                                // Nuevo formato
                                for (var cliente in parsed.pdfs) {
                                    if (parsed.pdfs.hasOwnProperty(cliente)) {
                                        var ruta = parsed.pdfs[cliente];
                                        // Transformar ruta absoluta a relativa para el navegador
                                        var relative = ruta.replace(/^.*?\/backend\/web\//, '/backend/web/');
                                        transformed.pdfs[cliente] = relative;
                                    }
                                }
                                for (var cliente in parsed.emails) {
                                    if (parsed.emails.hasOwnProperty(cliente)) {
                                        transformed.emails[cliente] = parsed.emails[cliente];
                                    }
                                }
                            } else {
                                // Formato antiguo: parsed es {cliente: ruta, ...}
                                for (var cliente in parsed) {
                                    if (parsed.hasOwnProperty(cliente)) {
                                        var ruta = parsed[cliente];
                                        var relative = ruta.replace(/^.*?\/backend\/web\//, '/backend/web/');
                                        transformed.pdfs[cliente] = relative;
                                    }
                                }
                            }
                            processed.data = transformed;
                        } catch (e) {
                            console.error('Error parseando data JSON:', e);
                            processed.data = { pdfs: {}, emails: {} };
                        }
                    }
                    return processed;
                });

                // Filtrar por cliente si hay texto
                if (vm.filtroCliente) {
                    var filtro = vm.filtroCliente.toLowerCase();
                    vm.signedDocs = docs.filter(function(doc) {
                        return Object.keys(doc.data.pdfs || {}).some(function(cliente) {
                            return cliente.toLowerCase().indexOf(filtro) !== -1;
                        });
                    });
                } else {
                    vm.signedDocs = docs;
                }

                vm.firmaLoading = false;
            }).catch(function(error) {
                console.error('Error cargando documentos:', error);
                vm.firmaLoading = false;
                vm.firmaErrorMessage = 'Error al cargar documentos. Intente nuevamente.';
            });
        };

        // Seleccionar un documento
        vm.seleccionarSignedDoc = function(doc) {
            vm.signedDocSeleccionado = doc;
        };


        // Descargar PDF
        vm.descargarPdfFirma = function(ruta) {
            window.open(ruta, '_blank');
        };

        // Confirmar PDF
        vm.confirmarPdf = function(pdfId) {
            if (!confirm('¿Está seguro que desea confirmar este documento?')) {
                return;
            }
            ShippingService.confirmarPdf(pdfId).then(function(response) {
                if (response.success) {
                    vm.cargarSignedDocs();
                }
            }).catch(function(error) {
                alert('Error al confirmar: ' + (error.message || 'Error desconocido'));
            });
        };


    }
})();
